import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../../base";
import { Customer } from "../../customers/customer";
import { WorkOrder } from "../../work-order/work-order";
import { WorkOrderPo } from "../../work-order-po/work-order-po";
import {
  IAddStellaInspectionNoteItem,
  IUpdateStellaInspectionNoteItem,
  StellaInspectionNoteItem,
} from "./stella-inspection-note-item";

export const StellaInspectionNote = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      number: types.maybeNull(types.string),
      workOrderId: types.maybeNull(types.string),
      workOrder: types.maybeNull(WorkOrder),
      workOrderPOId: types.maybeNull(types.string),
      workOrderPO: types.maybeNull(WorkOrderPo),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      inspectionDate: types.maybeNull(types.string),
      manufacturingDate: types.maybeNull(types.string),
      expireDate: types.maybeNull(types.string),
      conclusion: types.maybeNull(types.string),
      items: types.optional(types.array(StellaInspectionNoteItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IStellaInspectionNote
  extends Instance<typeof StellaInspectionNote> {}
export interface IStellaInspectionNoteProperties
  extends SnapshotIn<typeof StellaInspectionNote> {}
export interface IAddStellaInspectionNote
  extends Pick<
    IStellaInspectionNoteProperties,
    | "number"
    | "inspectionDate"
    | "workOrderPOId"
    | "manufacturingDate"
    | "expireDate"
    | "conclusion"
    | "customerId"
  > {
  items: IAddStellaInspectionNoteItem[];
}

export interface IUpdateInspectionStellaNote
  extends Pick<
    IStellaInspectionNoteProperties,
    | "number"
    | "inspectionDate"
    | "workOrderId"
    | "workOrderPOId"
    | "manufacturingDate"
    | "id"
    | "expireDate"
    | "conclusion"
    | "customerId"
  > {
  items: IUpdateStellaInspectionNoteItem[];
}
